import { RadioGroup } from '@pwc/pwc-deals-ui';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getSurveyResponses } from '../../../surveySlice';
import { validate } from '../../../common/services/utilities/surveyUtility';

const QuestionRadio = ({
  question,
  userAnswer,
  setUserAnswer,
  setIsAnswerValid,
}) => {
  const responses = useSelector(getSurveyResponses);

  useEffect(() => {
    const answer =
      responses &&
      responses.answers.find((ans) => ans.questionId === question.id);
    if (answer) {
      setUserAnswer(answer.optionId);
    } else {
      setUserAnswer(null);
    }
  }, [question.id, setUserAnswer, responses]);

  useEffect(() => {
    const { isValid } = validate.questionRadio(userAnswer);
    setIsAnswerValid(isValid);
  }, [userAnswer, setIsAnswerValid]);

  const options = question.options
    ? question.options.map((option) => ({
        label: option.text,
        value: option.id,
      }))
    : [];

  const field = {
    value: userAnswer && `${userAnswer}`,
    onChange: (event) => setUserAnswer(+event.target.value),
  };

  return <RadioGroup label={question.text} options={options} field={field} />;
};

export default QuestionRadio;
